export default "__VITE_ASSET__1c1b7c17__"